import { Component, OnInit, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { WorkflowComponentsService } from '../workflow-components.service';
import { ExpressionBuilderService } from '../expression-builder/expression-builder.service';
import { AuthService } from 'src/app/core-api/services/auth/auth.service';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { COMPONENT_UI } from '../workflow-components.models';

@Component({ template: '' })
export abstract class AbstractWorkflowResultComponent<T = any> implements AfterViewInit {
    @Input() model: T;
    @Input() value: any;
    formatStyle: any = null;
    COMPONENT_UI = COMPONENT_UI;
    
    constructor(
        protected workflowComponentsService: WorkflowComponentsService,
        protected expressionBuilderService: ExpressionBuilderService,
        protected authService: AuthService,
        protected cdf: ChangeDetectorRef,
    ) {
    }
    
    ngAfterViewInit() {
        this._evaluateConditionalFormating();
    }
    
    private async _evaluateConditionalFormating() {
        const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
        const formGroupId = workflowComponent.FORM_ID || '_FORM_';
        const expressions: any[] = workflowComponent.CONDITIONS_FORMATTING;
        const formValues = !!this.workflowComponentsService.context.formValues && !!this.workflowComponentsService.context.formValues[formGroupId] ? this.workflowComponentsService.context.formValues[formGroupId] : {};
        const eventValues: any = {};
        eventValues[formGroupId] = formValues;
        if (!!expressions) {
            const variablesEnvironment = this.authService.envVariables$.value;
            
            for(var i = 0; i < expressions.length; i++) {
                const expression = expressions[i];
                if (!!expression.FORMAT_CONDITIONS) {
                    const buildedExpression = await this.expressionBuilderService.doBuildExpression(expression.FORMAT_CONDITIONS, {
                        eventWorkflowValuesChanged: {formValues: eventValues},
                        environmentVariables: variablesEnvironment, 
                        formGroupId: formGroupId,
                        initialState: true,
                    });
                    if (buildedExpression == true && !!expression.FORMAT_STYLES) {
                        this.formatStyle = expression.FORMAT_STYLES;
                    } else {
                        this.formatStyle = null;
                    }
                    this.cdf.detectChanges();
                }
            }
        }
    }
}